const setSpousePassportNo = (data = null) => {
  return {
    type: 'SET_SPOUSEPASSPORTNO',
    data
  }
}

export default {
  setSpousePassportNo,
}
